module.exports = __webpack_public_path__ + "static/media/heic-icon.ec3f7c20.svg";